import axios from "axios";

const BASE = process.env.REACT_APP_WP_BASE_URL || "https://osuonomio.com";

export const getEndpoint = (lang) => ({
	wp: `${BASE}/${lang}/wp-json/wp/v2`,
	osm: `${BASE}/${lang}/wp-json/osm/v1`,
	acf: `${BASE}/${lang}/wp-json/acf/v3`,
});

export const getDataFromWordpress = async (lang = "it") => {
	const { wp, osm, acf } = getEndpoint(lang);

	const [
		{ data: pages },
		{ data: projects },
		{ data: typology },
		{ data: client },
		{ data: options },
		{ data: languages },
	] = await Promise.all([
		axios.get(`${wp}/pages`),
		axios.get(`${wp}/works?per_page=100`),
		axios.get(`${wp}/typology?per_page=100`),
		axios.get(`${wp}/client?per_page=100`),
		axios.get(`${acf}/options/options`),
		axios.get(`${osm}/languages`),
	]);

	return { pages, projects, typology, client, options, languages };
};
